import { where } from 'firebase/firestore';
import { Suppliers } from '@bridebook/models';

export function getSuppliersData(supplierIds: string[]) {
  const query = [where('id', 'in', supplierIds)];
  return Suppliers._.query(query).get();
}
